import './App.css';

import './Galaxy.css';
function App() {
  return (
    
      <div className="wrapper">
        
        <div className="one">Coding
          <div className='languages'>
           <ul><br/>
            <h4>C/C++</h4>
            <h4>Java</h4>
            <h4>Python</h4>
            <h4>HTML/CSS</h4>
            <h4>JavaScript</h4>
            <h4>-React, Node, p5, Electron</h4>
            <h4>Vibe coding</h4>
            </ul>
          </div>
        </div>
        <div className="two">About<br/>
          <div className='about'>I'm Shreya and while I have a ton of interests and hobbies, my twin passions are art and tech.
                As for art, illustration and various types of design fall under my skillset which I've honed over time.
                And as for tech, I'm currently pursuing engineering - the core of all tech. 
                While I enjoy and am continuously learning & coding in different domains ,
                I also love to learn about the latest tech events, devices and feature drops,
                how the landscape of tech is evolving, how the world is being impacted by tech in various ways and how I can contribute to this ever evolving field.</div>
        </div>
        <div className="three">Illustration and Graphic Design
            <div className='languages'>
           <ul><br/>
            <h4>Krita</h4>
            <h4>Adobe Fresco</h4>
            <h4>Infinite painter</h4>
             <h4>Canva</h4>
            </ul>
          </div>
          
        </div>
        <div className="four">Projects
          <div className='icon'>
            <div className='pdes'><a href='https://psa-bengaluru.vercel.app/' target='_blank' rel="noreferrer">PSA Bengaluru</a></div>
            
          </div>
          <div className='desc'>Transit alert app</div>
          <div className='icon1'>
            <div className='pdes'><a href='https://vibecompass.wixstudio.com/newform'>The Vibe Compass</a></div>
          </div>
          <div className='desc'>Entry for Newform web challenge</div>
        </div>
        <div className="five">
          <div className='img'></div>
        </div>
        <div className="six">Socials
          <div className='languages'>
        <ul>
           <h4><a href='https://www.linkedin.com/in/shreya-r-0399ab2a1/' target='_blank' rel="noreferrer" className='link'>LinkedIn </a></h4>
           <h4><a href='https://github.com/shreya8040' target='_blank' rel="noreferrer" className='link'>Github</a></h4>
           <h4><a href='https://x.com/shreya_r20' target='_blank' rel="noreferrer" className='link'>Twitter
           <h4><text className='smallt'>(yes it's still twitter)</text></h4></a></h4>
            
        </ul>
          </div>
        </div>
        <div className="seven">Certifications
          <div className='languages'><br/>
        <ul>
            <h4><a href ='https://www.linkedin.com/in/shreya-r-0399ab2a1/overlay/1751461749164/single-media-viewer/?profileId=ACoAAEjwsG0Bf9Qdr1WFHGEIMaMT-VP1UHxJmgo'>Bug Bounty contest</a></h4>
            <h4><a href ='https://drive.google.com/file/d/1yPVjlXXlbazj1U3yXfjRIPpCNAHLs1LT/view'>Deep Dive into Python Libraries</a></h4>
            <h4><a href ='https://drive.google.com/file/d/1rpBJAtHimuvKJijWvf1CT_td-ZPDHNYj/view?usp=sharing'>Newform Wixstudio Honorable Mention</a></h4>
        </ul>
        </div>
        </div>
        <div className="eight">Favorite Quote
          <div className='quote'>❝Any sufficiently advanced technology is indistinguishable from magic✨❞</div>
        </div>
        <div className='text'>Jack of all trades, skilled at some</div>
        
      </div>
    
  );
}

export default App;
